import api from '../utils/api';

export const list = async (projectId) => {
  const res = await api.get(`/projects/${projectId}/moodboard`);
  return Array.isArray(res.data) ? res.data : (res.data.files || []);
};

export const upload = async (projectId, files, onProgress) => {
  const formData = new FormData();
  files.forEach((f) => formData.append('files', f));
  const res = await api.post(`/projects/${projectId}/moodboard`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (evt) => {
      if (!onProgress || !evt.total) return;
      const p = Math.round((evt.loaded * 100) / evt.total);
      onProgress(p);
    }
  });
  return Array.isArray(res.data) ? res.data : (res.data.files || []);
};

export const download = async (projectId, fileId) => {
  const res = await api.get(`/projects/${projectId}/moodboard/${fileId}`, { responseType: 'blob' });
  return res.data;
};

export const remove = async (projectId, fileId) => {
  await api.delete(`/projects/${projectId}/moodboard/${fileId}`);
};
